"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const currency_1 = require("../config/currency");
const reducer_1 = __importDefault(require("../store/localizationReducer/reducer"));
const validationsData_1 = require("../utils/validationsData");
const useLocalizationReducer = (country, language, currencyCode) => {
    const validCurrencyCode = (0, validationsData_1.validateCurrencyCode)(currencyCode);
    const validLanguage = (0, validationsData_1.validateLanguage)(language);
    const initialState = {
        country: (0, validationsData_1.validateCountry)(country),
        language: validLanguage,
        currency: {
            code: validCurrencyCode,
            symbol: currency_1.supportedCurrency[validCurrencyCode],
        },
        availableCurrencies: [],
        availableLanguages: [],
        selectedParameters: {
            currencyCode: validCurrencyCode,
            language: validLanguage,
        }
    };
    const [state, dispatch] = (0, react_1.useReducer)(reducer_1.default, initialState);
    return {
        state, dispatch
    };
};
exports.default = useLocalizationReducer;
